import * as EventEmitter from "eventemitter3";
/**Listener of the event.
 * The listener is a function which takes only one parameter
 * which has same interface as declared in specialization of the emitter
 */
export type Listener<T> = (event: T) => any;

/**Event emitter with strict data structure of event.
 * Specify the structure of data when declare the emitter then
 * when using, all events and listeners have to obey this structure.
 * Create one for each type of event.
 */
export class TypedEventEmitter<T> {
    private _eventListener = new EventEmitter();
    private readonly DEFAULT_EVENT: string = "default_event";
    constructor() {
    }
    get listenerAppender() {
        return this.getListenerAppender();
    }
    /** The call this function to get appender to add new listener for the event */
    private getListenerAppender() {
        const _appendInScope = (listener: Listener<T>) => {
            this._eventListener.on(this.DEFAULT_EVENT, listener);
        };
        return _appendInScope;
    }
    /** Remove all listeners */
    public off() {
        this._eventListener.removeAllListeners();
    }
    /** Emit the event */
    public emit(data: T) {
        this._eventListener.emit(this.DEFAULT_EVENT, data);
    }
}
// another more complex implementation: https://github.com/bterlson/strict-event-emitter-types
// TODO: add relay event
